import { createFileRoute, redirect } from '@tanstack/react-router'
import { InvoiceFormScreen } from '@/features/accounting-invoices/invoice-form-screen'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for creating an invoice.
 *
 * The grant guard is presentation only. The API enforces
 * `accounting_invoice.create` on POST /accounting/invoices, so a stale grant
 * still 403s server-side; this keeps a user without it out of a screen they
 * cannot use.
 *
 * `?duplicateOf=<id>` (R-28) is the Duplicate action's channel: the form
 * hydrates its header and lines from that invoice instead of from nothing.
 */
export const Route = createFileRoute('/_authenticated/accounting/invoices/new')({
  validateSearch: (search: Record<string, unknown>): { duplicateOf?: string } => ({
    duplicateOf: typeof search.duplicateOf === 'string' ? search.duplicateOf : undefined,
  }),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_invoice.create')) {
      throw redirect({ to: '/accounting/invoices' })
    }
  },
  component: InvoiceFormNewRoute,
})

function InvoiceFormNewRoute() {
  const { duplicateOf } = Route.useSearch()

  return <InvoiceFormScreen duplicateOf={duplicateOf} />
}
